import React, { useEffect, useRef } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import uiStore from 'stores/uiStore'
import './ConfirmDialog.scss'

const VARIANT_META = {
  danger: {
    icon: 'fas fa-exclamation-triangle',
    iconClass: 'app-dialog__icon--danger',
    confirmVariant: 'danger',
  },
  warning: {
    icon: 'fas fa-exclamation-circle',
    iconClass: 'app-dialog__icon--warning',
    confirmVariant: 'warning',
  },
  info: {
    icon: 'fas fa-info-circle',
    iconClass: 'app-dialog__icon--info',
    confirmVariant: 'primary',
  },
  success: {
    icon: 'fas fa-check-circle',
    iconClass: 'app-dialog__icon--success',
    confirmVariant: 'success',
  },
  primary: {
    icon: 'fas fa-question-circle',
    iconClass: 'app-dialog__icon--primary',
    confirmVariant: 'primary',
  },
}

const ConfirmDialog = () => {
  const { t } = useTranslation()
  const footerRef = useRef(null)
  const dialog = uiStore.dialog

  useEffect(() => {
    if (!dialog?.open) return undefined
    const timer = window.setTimeout(() => {
      const confirmBtn = footerRef.current?.querySelector('[data-app-dialog-confirm]')
      if (confirmBtn instanceof HTMLElement) confirmBtn.focus()
    }, 50)
    return () => window.clearTimeout(timer)
  }, [dialog?.open])

  if (!dialog) return null

  const meta = VARIANT_META[dialog.variant] || VARIANT_META.primary
  const confirmVariant = dialog.confirmButtonVariant || meta.confirmVariant

  return (
    <Modal
      show={dialog.open}
      onHide={() => uiStore.resolveDialog(false)}
      centered
      backdrop="static"
      keyboard
      className="app-dialog"
      aria-labelledby="app-dialog-title"
    >
      <Modal.Body className="app-dialog__body">
        <div className={`app-dialog__icon ${meta.iconClass}`} aria-hidden="true">
          <i className={meta.icon} />
        </div>
        <div className="app-dialog__content">
          <h5 id="app-dialog-title" className="app-dialog__title">
            {dialog.title || t('attention')}
          </h5>
          <p className="app-dialog__message">{dialog.message}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="app-dialog__footer">
        <div className="app-dialog__actions" ref={footerRef}>
          {dialog.showCancel !== false && (
            <Button
              variant="outline-secondary"
              className="app-dialog__btn"
              onClick={() => uiStore.resolveDialog(false)}
            >
              {dialog.cancelLabel || t('cancel')}
            </Button>
          )}
          <Button
            variant={confirmVariant}
            className="app-dialog__btn"
            data-app-dialog-confirm
            onClick={() => uiStore.resolveDialog(true)}
          >
            {dialog.confirmLabel || t('confirm')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default observer(ConfirmDialog)
